var Validateform = function(formElm) {

    const errorTemplate = '<span class="whi__mf__group__help" {{ type }}>{{ message }}</span>'
    const messageTypes = {
        error: 'data-jsValidateError',
        original: 'data-jsValidateHelp'
    }
    var inputElms;


    var html5ValidTest = function(Elm) {
        return !Elm.validity.valid;
    };

    var templateStringToElement = function(html) {
        let template = document.createElement('template');
        template.innerHTML = html;
        return template.content.firstChild;
    }

    var getGroupElement = function(Elm) {
        let myParent = Elm.parentElement;
        if (myParent.classList && myParent.classList.contains('whi__mf__group')) {
            return myParent;
        } else {
            return false;
        }
    }

    var getAllFormElements = function(form) {
        let elements = [];
        let elementQuerys = [
            'textarea',
            'select',
            'input[type="email"]',
            'input[type="tel"]',
            'input[type="url"]',
            'input[type="text"]',
            'input[type="password"]',
            'input[type="radio"]',
            'input[type="checkbox"]',
            'input[type="number"]'
        ]

        for (let selector of elementQuerys) {
            let detectedElms = form.querySelectorAll(selector);
            if (detectedElms.length > 0) {
                for (let i = 0; i < detectedElms.length; i++) {

                    /** Detecting if there are helper texts present in the form. making sure the data is not lost. */
                    let myGroup = getGroupElement(detectedElms[i]);
                    if (myGroup && myGroup.querySelector('[data-jsValidateHelp]') !== null) {
                        detectedElms[i].jsValidateHelp = myGroup.querySelector('[data-jsValidateHelp]').innerHTML;
                    }

                    elements.push(detectedElms[i]);
                }
            }
        }

        return elements;
    };

    var checkForm = function() {
        let invalid = inputElms.filter(html5ValidTest);
        if (invalid.length === 0) {
            return true;
        } else {
            return false;
        }
    };

    var clearAllErrors = function() {
        for (let i = 0; i < inputElms.length; i++) {
            renderNormal(inputElms[i]);
            inputElms[i].removeEventListener('keyup', keyUpListener);
        }
    };

    var renderError = function(Elm) {
        let myGoup = getGroupElement(Elm);
        myGoup.classList.add('whi__mf__group--haserror');
        if (Elm.dataset.jsvalidateerror && Elm.dataset.jsvalidateerror.length > 0) {
            let myErrorHtml = errorTemplate
                .replace('{{ type }}', messageTypes.error)
                .replace('{{ message }}', Elm.dataset.jsvalidateerror);
            if (myGoup.querySelector('.whi__mf__group__help') !== null) {
                myGoup.replaceChild(templateStringToElement(myErrorHtml), myGoup.querySelector('.whi__mf__group__help'));
            } else {
                myGoup.appendChild(templateStringToElement(myErrorHtml))
            }
        }
    };

    var renderNormal = function(Elm) {
        let myGoup = getGroupElement(Elm);
        if (myGoup.classList && myGoup.classList.contains('whi__mf__group--haserror')) {
            myGoup.classList.remove('whi__mf__group--haserror');
            if (Elm.jsValidateHelp) {
                let myOriginalHtml = errorTemplate
                    .replace('{{ type }}', messageTypes.original)
                    .replace('{{ message }}', Elm.jsValidateHelp);
                myGoup.replaceChild(templateStringToElement(myOriginalHtml), myGoup.querySelector('.whi__mf__group__help'));
            } else {
                myGoup.removeChild(myGoup.querySelector('.whi__mf__group__help'));
            }
        }
    };

    var processErrors = function() {
        var invalidElms = inputElms.filter(html5ValidTest);
        for (let i = 0; i < invalidElms.length; i++) {
            renderError(invalidElms[i]);
            invalidElms[i].addEventListener('keyup', keyUpListener);
        }
    };

    var focusOutListener = function(event) {
        let myGoup = getGroupElement(event.target);
        if (event.target.value.length > 0) {
            myGoup.classList.add('whi__mf__group--hasvalue');
        } else {
            myGoup.classList.remove('whi__mf__group--hasvalue');
        }
    };

    var keyUpListener = function(event) {
        if (event.target.validity.valid) {
            renderNormal(event.target);
        } else {
            renderError(event.target);
        }
    };

    var setMainListener = function() {
        formElm.addEventListener('submit', function(event) {
            clearAllErrors();
            var valid = checkForm();
            if (!valid) {
                event.preventDefault();
                processErrors();
            }
        }, false);
        var hasValueElms = formElm.querySelectorAll('textarea, input[type="password"], input[type="email"], input[type="tel"], input[type="url"], input[type="text"], input[type="number"]');
        for (let i = 0; i < hasValueElms.length; i++) {
            hasValueElms[i].addEventListener('blur', focusOutListener);
            if (hasValueElms[i].value.length > 0) {
                let myGroup = getGroupElement(hasValueElms[i]);
                myGroup.classList.add('whi__mf__group--hasvalue');
            }
        }
    };


    var init = function() {
        inputElms = getAllFormElements(formElm);
        setMainListener();
    }
    init();

}

/**
 * Loop over all forms with data attribute and instantiate a validator
 */
var myForms = document.querySelectorAll('[data-jsValidate="true"]');
for (let i = 0; i < myForms.length; i++) {
    new Validateform(myForms[i]);
}
